import { render, staticRenderFns } from "./Notificationmgmt.vue?vue&type=template&id=78c41eac&scoped=true&"
import script from "./Notificationmgmt.vue?vue&type=script&lang=js&"
export * from "./Notificationmgmt.vue?vue&type=script&lang=js&"
import style0 from "./Notificationmgmt.vue?vue&type=style&index=0&id=78c41eac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c41eac",
  null
  
)

export default component.exports